import React, { useState } from "react";
import { toast } from "react-toastify";
import { Box, Typography } from "@mui/material";
import "@fontsource-variable/inter";
import MainLayout from "../../components/layout/MainLayout";
import Form from "./Form/Form";
import Payment from "./Payment/Payment";
import AccountDetails from "./Payment/AccountDetails";
import RegisterContext, { initialValues } from "../../context/RegisterContext";
import CircleLoad from "../../components/Spinner/CircleLoad";
function Register() {
  const [state, dispatch] = useState(initialValues);

  const [modalState, setModalState] = useState({
    payment: false,
    accountDetails: false,
  });
  const [authState, setAuthState] = useState(
    "register" as "register" | "confirm"
  );

  const handleCloseModal = (field: string) =>
    dispatch((prev) => ({
      ...prev,
      [field]: false,
    }));

  return (
    <RegisterContext.Provider value={{ dispatch, state }}>
      <MainLayout>
        <Card>
          <Box>
            {/* <Typography
            variant="h2"
            align="center"
            fontFamily="'Inter Variable', sans-serif"
          >
            Onboard
          </Typography> */}
            <Box mt={1}>
              {/* <Flutterwave /> */}
              {/* <Remita /> */}
              <Form setModalState={setModalState} setAuthState={setAuthState} />

              <Payment
                open={state.payment}
                handleClose={() => handleCloseModal("payment")}
              />
              <AccountDetails
                open={state.accountDetails}
                handleClose={() => handleCloseModal("accountDetails")}
              />

              <CircleLoad color="#d6c0e7" loading={state.openSpinner} />
            </Box>
          </Box>
        </Card>
      </MainLayout>
    </RegisterContext.Provider>
  );
}
function Card(props: IWrapper) {
  return (
    <Box
      sx={{
        borderRadius: 3,
        bgcolor: "white",
        boxShadow: {
          md: "3px 3px 7px rgba(93,38,132, 0.1), -3px -3px 7px rgba(93,38,132, 0.1)",
        },
        p: {
          xs: 0,
          md: 5,
        },
        m: {
          xs: 2,
          md: 5,
        },
        pt: 2,
        pb: {
          xs: 5,
        },
      }}
    >
      {props.children}
    </Box>
  );
}
export default Register;
